import React from 'react';
import ReactDOM from 'react-dom';
import 'core-js/stable';
import 'lazysizes';
import 'lazysizes/plugins/attrchange/ls.attrchange';
import { loadableReady } from '@loadable/component';
import '@joybird/joystagram-components/src/styles/globals-tailwind.css';
import avo from '@joybird/joystagram-components/dist/esm/avoAnalytics';
import requestIdleCallback from '@joybird/joystagram-components/dist/esm/requestIdleCallback';
import initAvo from '@joybird/joystagram-components/dist/esm/initAvo';
import polyfills from './polyfills';
import { isClient } from './app/globals';
import { fetchPolyfills } from './commons/utils';
import initSentry from './commons/initSentry';
import AppWithProviders from './app/AppWithProviders';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import '@joybird/joystagram-components/dist/tailwind-preflight.css';
import '@joybird/joystagram-components/dist/tailwind.css';

initSentry();

if (isClient()) {
  initAvo();

  // register public Event
  requestIdleCallback(() => {
    window.jbEvent = { emailAcquired: avo.emailAcquired };
  });
}

const isSSR = !!isClient() && !!window.__ROUTE_STATE__;
const initData = isSSR ? window.__ROUTE_STATE__ : {};

if (isSSR) {
  delete window.__ROUTE_STATE__;
}

if (isClient()) {
  window.addEventListener('error', (_, __, ___, ____, error) => {
    if (error && error.name === 'SyntaxError') {
      window.location.reload(true);
    }
  });
}

const app = () => {
  if (isSSR) {
    if (isClient()) {
      loadableReady(() => {
        ReactDOM.hydrate(
          <AppWithProviders initData={initData} />,
          document.getElementById('root')
        );
      });
    }
  } else {
    ReactDOM.render(
      <AppWithProviders initData={null} />,
      document.getElementById('root')
    );
  }
};

fetchPolyfills(app, polyfills);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
